import { render, staticRenderFns } from "./TrustPageForm.vue?vue&type=template&id=27b96de2&"
import script from "./TrustPageForm.vue?vue&type=script&lang=js&"
export * from "./TrustPageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports